/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        khariHatDark: hsl(28, 10, 48),
        khariHatMedium: hsl(28, 13, 56),
        khariHatLight: hsl(28, 15, 61),
    },
}
